export default __webpack_public_path__ + "static/media/upton.2dcac464.png";